export default __webpack_public_path__ + "static/media/04.9a2156dc.jpg";